import { render, staticRenderFns } from "./DlgCompanyDelete.vue?vue&type=template&id=72d146e2&scoped=true"
import script from "./DlgCompanyDelete.vue?vue&type=script&lang=js"
export * from "./DlgCompanyDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d146e2",
  null
  
)

export default component.exports